import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { CrmTranslatePipe } from 'common-module/translate';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { VersionService } from '@app/core/services/version.service';
import { environment } from '@environments/environment';
import { CrmVersionDetectorService } from 'common-module/version';
import { CrmLayoutV2FragmentDirective } from 'common-module/layout-v2';
import {
  CrmChangelogModule,
  CrmChangelogService,
} from 'common-module/changelog';

export interface ModuleVersion {
  module: string;
  version: string;
}

@Component({
  selector: 'app-brand-mark',
  templateUrl: './brand-mark.component.html',
  styleUrls: ['./brand-mark.component.less'],
  imports: [
    CrmChangelogModule,
    NgIf,
    CrmTranslatePipe,
    NzButtonModule,
    NzToolTipModule,
    NzIconModule,
    NgClass,
    NgForOf,
  ],
  standalone: true,
})
export class BrandMarkComponent
  extends CrmLayoutV2FragmentDirective<any>
  implements OnInit
{
  /**
   * Project name displayed in brand mark
   */
  @Input() public brandName = environment.projectName;
  /**
   * Environment name displayed in brand mark
   */
  @Input() public env: string = environment.env;
  /**
   * Project version displayed in brand mark
   */
  @Input() public version: string;
  /**
   * Path to project logo displayed in brand mark
   */
  @Input() public logoPath = './assets/images/development_logo.svg';
  /**
   * Flag indicating that project is production. Then there is no env displayed.
   */
  @Input() public production: boolean;
  /**
   * Flag indicates that new version of project is available, version and env is marked
   * as red. Message and button are show to reload application
   */
  @Input() public newVersionAvailable: boolean;
  /**
   * Versions of backend modules available for given env. Displayed in tooltip
   * on mouse hover on project name
   */
  @Input() public moduleVersions: ModuleVersion[];
  /**
   * Display compact version of brand mark to fit collapsed sider navigation.
   */
  @Input() public compact: boolean;
  @Input() public showBrandLogo = true;
  /**
   * EventEmitter for reload action handling
   */
  @Output() public reloadClicked = new EventEmitter<void>();

  private versionService = inject(VersionService);
  private versionDetectorService = inject(CrmVersionDetectorService);
  private changelogService = inject(CrmChangelogService);

  ngOnInit() {
    // Display changelog modal after layout is initialized. Not on app loading.
    this.changelogService.changelogModal();
    this.siderControl.collapsed$.subscribe((isCollapsed) => {
      this.compact = isCollapsed;
    });

    this.version = environment.version;
    this.versionService.getApiVersion().subscribe((moduleVersion) => {
      this.moduleVersions = [
        {
          module: 'Teamfolio',
          version: moduleVersion,
        },
      ];
    });

    this.versionDetectorService.appUpdateAvailable$.subscribe(
      (updateAvailable) => {
        if (!updateAvailable) {
          return;
        }

        this.newVersionAvailable = true;
      },
    );
  }
}
